/*
 * File: input-check.ts
 * File Created: 2024-09-13 09:29:09
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-24 06:56:34
 * Modified By: Val Liu
 * -----
 */

import { Component, Prop } from "vue-property-decorator";

import { PropInnateSync } from "@root/core/vue-props";
import { BaseInputComponent } from "../core/lib/base-input-component";

@Component
export default class InputCheck extends BaseInputComponent {
    @PropInnateSync("value", { type: [String, Number, Array], default: null })
    innateValue!: string | number | string[] | number[] | null;

    /// name / value pair of the select / options
    @Prop({ type: Object, default: () => ({}) })
    options!: any;

    /// private helpers
    get generatedOptions() {
        return Object.keys(this.options).map((name) => ({
            key: this.$_(name),
            value: this.options[name],
        }));
    }
}
